<div class="relative inline-block w-full h-full">
  <div [inlineSVG]="iconPath" [class]="classes"></div>

  <!-- Notification & DM badges  -->
  @if (name === 'notifications' && data?.hasUnreadNotifications) {
    <span
    class="absolute top-[20%] left-[47%] inline-flex items-center justify-center w-[15.18px] h-[11px] bg-[#C83764] text-white rounded-lg text-[8px] leading-[12px] border-solid border-white border-[1px] px-2 py-[6px] text-center"
    >
    {{ data?.unreadNotificationCount }}
  </span>
  }
  @if (name === 'navigation-chat' && data?.unreadDirectMessagesCount) {
    <span
    class="absolute top-[20%] left-[47%] inline-flex items-center justify-center w-[15.18px] h-[11px] bg-[#C83764] text-white rounded-lg text-[8px] leading-[12px] border-solid border-white border-[1px] px-2 py-[6px] text-center"
    >
    {{ data?.unreadDirectMessagesCount }}
  </span>
  }
</div>
